import { clearContextEventTrigger } from "@hooks/useClearContext";
import { message } from "@src/constants";
import { clearCookies } from "@utils/clearCookies";
import axios from "axios";
import Cookies from "js-cookie";

const getAuthToken = () => {
  const userData = Cookies.get("userData") || "";
  const parsedUserData = userData ? JSON.parse(userData) : null;
  const userToken: string = parsedUserData?.access_token;
  return userToken || "";
};

const getHeader = () => {
  return {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Access-Control-Allow-Headers": "X-Requested-With,content-type",
    "Access-Control-Allow-Methods": "GET, PATCH",
    Authorization: `Bearer ${getAuthToken()}`,
  };
};

const handleUnauthorized = () => {
  // clear local storage and cookies
  localStorage.clear();
  clearCookies();
  clearContextEventTrigger();
};

const handleError = (err: HandleErrorType) => {
  // unauth error
  if (err?.response && err?.response?.status === 401) {
    handleUnauthorized();

    if (
      err?.message === "jwt expired" ||
      err?.response?.data?.message === "jwt expired"
    )
      return {
        data: null,
        status: err?.response?.status,
        error: { message: message.ERROR_MESSAGE_SESSION_EXPIRED },
      };

    return {
      data: null,
      status: err?.response?.data?.status_code || err?.response?.status,
      error: {
        message:
          err?.response?.data?.message ||
          err?.message ||
          message.ERROR_MESSAGE_UNAUTHORIZED,
      },
    };
  }
  return {
    data: null,
    status: err?.response?.data?.status_code || err?.response?.status,
    error: {
      message:
        err?.response?.data?.message || err?.message || message.ERROR_MESSAGE,
    },
  };
};

const services = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: (url: string, params?: any) => {
    const headers = getHeader();
    const BASE_URL = process.env.REACT_APP_BASEURL_API;

    return new Promise((resolve, reject) => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let dataForMethod: any = { headers };
        if (params) {
          dataForMethod = { ...dataForMethod, params };
        }
        axios
          .get(`${BASE_URL}${url}`, dataForMethod)
          .then((res) => {
            if (res?.data?.status_code !== 200) {
              reject(handleError(res?.data));
            }
            resolve({ data: res.data, status: res.status, error: null });
          })
          .catch((err) => {
            reject(handleError(err));
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch: (url: string, params: any) => {
    return new Promise((resolve, reject) => {
      const headers = getHeader();
      const BASE_URL = process.env.REACT_APP_BASEURL_API;

      try {
        axios
          .patch(`${BASE_URL}${url}`, { ...params }, { headers })
          .then((res) => {
            resolve({
              data: res.data,
              status: res.status,
              success: res.status === 200,
              error: null,
            });
          })
          .catch((err) => {
            reject(handleError(err));
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  post: (url: string, body: object) => {
    return new Promise((resolve, reject) => {
      const headers = getHeader();
      const BASE_URL = process.env.REACT_APP_BASEURL_API;

      try {
        axios
          .post(`${BASE_URL}${url}`, { ...body }, { headers })
          .then((res) => {
            resolve({
              data: res.data,
              status: res.status,
              success: res.status === 200,
              error: null,
            });
          })
          .catch((err) => {
            reject(handleError(err));
          });
      } catch (err) {
        reject(err);
      }
    });
  },
};
export default services;
